<template>
  <v-menu 
    ref="filterMenu"
    offset-y 
    transition="slide-y-transition"
    :close-on-content-click="false"
    data-testid="financialclose-filtermenu-vmenu"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-tooltip
        bottom
        content-class="tooltip-bottom"
      >
        <template v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }">
          <v-btn
            v-bind="{ ...attrs, ...tooltipAttrs }"
            v-on="{ ...on, ...tooltipOn }"
            class="shadow-off"
            icon
            data-testid="financialclose-filtermenu-button"
          >
            <v-icon size="24">mdi-filter</v-icon>
          </v-btn>
        </template>
        <span>Filter</span>
      </v-tooltip>
    </template>

    <v-list class="filter-menu pa-0 ma-0 d-flex flex-column align-start justify-start all-width" data-testid="financialclose-filtermenu-vlist">
      <!-- Header -->
      <v-list-title class="ma-0 all-width" data-testid="financialclose-filtermenu-listtitle">
        <div class="d-flex filter-menu-header align-center pa-2 pb-3 pt-3 pb-1 justify-space-between" data-testid="financialclose-filtermenu-header">
          <p class="ma-0 font-weight-bold">Filter Tasks</p>
          <v-icon color="primary">mdi-filter</v-icon>
        </div>
      </v-list-title>
      <v-divider class="filter-menu-divider"></v-divider>
      
      <!-- Filter Options -->
      <v-list-item class="filter-menu-list d-flex all-width align-start pa-0 ma-0 flex-column" data-testid="financialclose-filtermenu-listitem">
        <v-list-item 
          v-for="option in filterOptions" 
          :key="option.value"
          class="filter-menu-item d-flex pa-0 ma-0 all-width align-center"
          :class="{ selected: selectedFilter === option.value }"
          @click="selectFilter(option.value)"
          data-testid="financialclose-filtermenu-option"
        >
          <div class="filter-menu-item-text" data-testid="financialclose-filtermenu-option-text">
            <span>{{ option.name }}</span>
          </div>
          <div class="filter-menu-check-icon" data-testid="financialclose-filtermenu-option-icon">
            <v-icon>mdi-check</v-icon>
          </div>
        </v-list-item>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import './FilterMenu.scss';
import { getTaskTypeOptions } from "../../utils/utils";

export default {
  name: 'FilterMenu',
  props: {
    selectedFilter: {
      type: String,
      default: 'all'
    }
  },
  data() {
    return {
      filterOptions: [
        { value: 'all', name: 'All Tasks' },
        ...getTaskTypeOptions()
      ]
    }
  },
  methods: {
    selectFilter(filterValue) {
      this.$emit('filter-changed', filterValue)
      // Close the menu after selection
      this.$refs.filterMenu.isActive = false
    }
  }
}
</script>